import React from 'react';

const ActionButtons = ({ onEvaluate, onSavePDF, showResults }) => {
  return (
    <div className="max-w-md mx-auto mt-16 space-y-4">
      <button
        onClick={onEvaluate}
        className="w-full py-4 px-8 rounded-2xl font-bold text-lg transition-all duration-500 transform hover:scale-105 focus:outline-none focus:ring-4"
        style={{
          background: 'linear-gradient(135deg, #01918C 0%, #02c7c0 100%)',
          color: 'white',
          boxShadow: '0 15px 35px rgba(1, 145, 140, 0.3)',
          focusRingColor: 'rgba(1, 145, 140, 0.3)'
        }}
      >
        ✨ Eredmény kiértékelése
      </button>
      
      {showResults && (
        <button
          onClick={onSavePDF}
          className="w-full py-3 px-6 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 border-2"
          style={{
            backgroundColor: 'transparent',
            borderColor: '#01918C',
            color: '#01918C'
          }}
        >
          📄 Eredmény mentése PDF-be
        </button>
      )}
    </div>
  );
};

export default ActionButtons;